module.exports = import("https://unpkg.com/web-vitals@4?module");;